import { render, staticRenderFns } from "./AccFoodGraphics.vue?vue&type=template&id=2def615a&scoped=true&"
import script from "./AccFoodGraphics.vue?vue&type=script&lang=js&"
export * from "./AccFoodGraphics.vue?vue&type=script&lang=js&"
import style0 from "./AccFoodGraphics.vue?vue&type=style&index=0&id=2def615a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def615a",
  null
  
)

export default component.exports